import http from "@/http-common";

const BASE = "statistics/schedule";

class WeeklyScheduleStatisticsService {
  getWeeklyProgress(weekStartDate, gradeId) {
    return http.get(`${BASE}/weekly-progress`, {
      params: { weekStartDate, gradeId }
    });
  }

  downloadAttachment(attachmentId) {
    return http.get(`/schedules/download2/${attachmentId}`, { responseType: "blob" });
  }
}

export default new WeeklyScheduleStatisticsService();
